import { Children, type ReactNode } from "react";

import { cn } from "@/lib/utils";

interface BreadcrumbsProps {
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  label: string;
  listClassName?: string;
  separatorClassName?: string;
}

/** Renders the application breadcrumb pattern with a leading slash on every item. */
export function Breadcrumbs({
  actions,
  children,
  className,
  label,
  listClassName,
  separatorClassName,
}: BreadcrumbsProps) {
  const items = Children.toArray(children);

  return (
    <nav
      aria-label={label}
      className={cn("flex min-w-0 flex-wrap items-center text-sm", className)}
    >
      <ol className={cn("flex min-w-0 flex-wrap items-center gap-2", listClassName)}>
        {items.map((item, index) => (
          <li
            key={index}
            aria-current={index === items.length - 1 ? "page" : undefined}
            className="flex min-w-0 items-center gap-2"
          >
            <span aria-hidden="true" className={cn("text-muted-foreground", separatorClassName)}>
              /
            </span>
            {item}
          </li>
        ))}
      </ol>
      {actions ? <div className="ml-auto">{actions}</div> : null}
    </nav>
  );
}
